import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import React from 'react';

import * as css from '@app/feature/emsp-bo-rfid-badge-order/emsp-bo-rfid-badge-order-details/emsp-bo-rfid-badge-order-details.module.scss';

import { EmspBoRfidBadgeOrderBillingAddressDetailsController } from '../../../emsp-bo-rfid-badge-order-billing-address-details/emsp-bo-rfid-badge-order-billing-address-details.controller';
import { EmspBoRfidBadgeOrderShippingAddressDetailsController } from '../../../emsp-bo-rfid-badge-order-shipping-address-details/emsp-bo-rfid-badge-order-shipping-address-details.controller';
import { GeneralCardComponent } from './cards/general-card.component';

export const InformationTabComponent = (): React.JSX.Element => (
  <Stack className={css.informationTab} direction="row" gap={GapEnum.L}>
    <Stack direction="column" gap={GapEnum.L} flex={1}>
      <GeneralCardComponent />
    </Stack>
    <Stack direction="column" gap={GapEnum.L} flex={1}>
      <EmspBoRfidBadgeOrderBillingAddressDetailsController />
      <EmspBoRfidBadgeOrderShippingAddressDetailsController />
    </Stack>
  </Stack>
);
